export const SearchTypes = {
  SET_QUERY: "products/SET_QUERY",
};

export const setSearchQuery = (payload) => ({
  type: SearchTypes.SET_QUERY,
  payload,
});
